/**
 * Created by stephanpudras on 17.05.18.
 */

import React from 'react';
import {connect} from 'react-redux';
import FeedbackActions from "../FeedbackActions";
import SVGProgressCircle from "../../../components/SVGProgressCircle";
import FileSaver from 'file-saver';
import Survey from '../../survey/view/Survey';
import 'ionicons/dist/css/ionicons.min.css';
import BaseURL from "../../../api/BaseURL";


const mapStateToProps = (state) => {
    return {
        timer: state.feedback.timer,
        downloadProgress: state.feedback.feedbackDownloadInfo,
        fileEnglish: state.feedback.fileEnglish,
        fileGerman: state.feedback.fileGerman,
        language: state.application.language,
        indicator: state.feedback.indicator,
        token: state.application.token.token
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        startFeedbackTimer: (timer) => dispatch(FeedbackActions.startFeedbackTimer(timer)),
        startDownload: () => dispatch(FeedbackActions.startDownload()),
        startRequests: (interval, indicatorInterval) => dispatch(FeedbackActions.startRequests(interval, indicatorInterval)),
        //getDownloads: () => dispatch(FeedbackActions.getDownloads()),
        setIndicatorInitial: (timespan) => dispatch(FeedbackActions.setIndicatorInitial(timespan)),
        saveDownloadStats:(language) => dispatch(FeedbackActions.saveDownloadStats(language))
    }
};

class FeedbackMain extends React.Component {
    constructor(props){
        super(props);
        this.inquire = this.inquire.bind(this);
        this.state = {ready: false};
    }

    componentDidMount(){
        //if(this.props.token !== "undefined" && this.props.token !== null && this.props.downloadProgress.interval == null){
        //   this.props.getDownloads();
        //}
        this.props.startFeedbackTimer(setTimeout(() => {this.inquire()}, Math.floor(Math.random() * 1000) + 8000));
        //this.props.setIndicatorInitial(10000);
    }

    inquire(){
        this.setState({ready: true});
    }

    render() {
        return (
          <div className="view">
            <div className="row">
              <div style={{marginTop:"10em"}} className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-12">
                <h3>{this.props.language.map !== null ? this.props.language.map.header.feedback.header1 : ""}</h3>
                <p>
                  {this.props.language.map !== null ? 
                    (
                      this.props.language.map.text.feedback.split('\n').map((item, key) => {
                          if(item.indexOf("[mailto]") > -1){
                              let aIdx = item.indexOf("[mailto]");
                              let bIdx = item.lastIndexOf("[mailto]");
                              let itemSplicedA = item.split("[mailto]");
                              let mailto = <a href="mailto:abciteam@ackerschott.eu">abciteam@ackerschott.eu</a>;
                              return <span key={"f_t_" + key}>{itemSplicedA[0]}{mailto}{itemSplicedA[1]}<br/></span>
                          }else
                              return <span key={"f_t_" + key}>{item}<br/></span>
                      }
                    ))
                    :
                     ""
                  }
              </p>
              </div>
              <div className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-12">
                  {
                      this.props.language.map !== null ?
                          <Survey/>
                          :
                          null
                  }

              </div>
              <div style={{marginTop:"5em", textAlign:"center"}} className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-9 col-md-10 col-sm-11 col-xs-12">
                {
                    !this.state.ready ?
                        <SVGProgressCircle
                            data={this.props.indicator}
                        />
                        :
                        (
                            this.props.language.map !== null ?
                                <div className="row">
                                    <div className="col-12 form-group">
                                        <div className="col-12">
                                            <div className="offset-xl-3 offset-lg-3 offset-md-3 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <a className="btn btn-outline-primary btn-block" href={BaseURL.getBaseURL() + "/api/feedback/download/" + this.props.token + "/de"} type="application/pdf"
                                                   download={this.props.downloadProgress.fileNameDe}>{this.props.language.map.labels.feedback.downloadDe} <span className="ion-md-cloud-download"> </span> </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 form-group">
                                        <div className="col-12">
                                            <div className="offset-xl-3 offset-lg-3 offset-md-3 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <a className="btn btn-outline-primary btn-block" href={BaseURL.getBaseURL() + "/api/feedback/download/" + this.props.token + "/en"} type="application/pdf"
                                                   download={this.props.downloadProgress.fileNameEn}>{this.props.language.map.labels.feedback.downloadEn} <span className="ion-md-cloud-download"> </span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                        )
                }
              </div>
            </div>
          </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackMain)



// WEBPACK FOOTER //
// ./src/modules/feedback/view/FeedbackMain.js